"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const link = e.target || e || {};
    if (!link || (link && !link.href))
        link['href'] = null;
    const text = !link.textContent || link.textContent === '' || link.textContent === 'X'
        ? link.getAttribute('aria-label')
        : link.textContent.trim() || 'NA';
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    window.adobeDataLayer.push({
        component: {
            linkClick: null,
        },
    });
    const analyticsEvent = {};
    analyticsEvent.component = {
        linkClick: {
            'dc:title': `${text}`,
            'xdm:linkURL': `${link.href}`,
        },
    };
    analyticsEvent.event = 'cmp:click';
    analyticsEvent.eventInfo = {
        path: 'component.linkClick',
    };
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
